import { type CommandItem, type IconName, toggleTheme } from "@nabble/ui";
import type { AppModule } from "./appModules";
import { moduleLanding, type NavTarget } from "./navigation";

export interface CommandSources {
  appModules: AppModule[];
  targets: NavTarget[];
  navigate: (path: string) => void;
  logout: () => void;
}

/** The command palette: open a module, go to any section, change theme, sign out. */
export function paletteCommands({ appModules, targets, navigate, logout }: CommandSources): CommandItem[] {
  return [
    ...appModules.map((m) => ({
      id: `module.${m.id}`,
      label: m.label,
      group: "Modules",
      icon: m.icon,
      keywords: m.sections.map((s) => s.label),
      onSelect: () => navigate(moduleLanding(m)),
    })),
    ...targets.map((t) => ({
      id: `go.${t.id}`,
      label: t.module ? `${t.module} › ${t.label}` : t.label,
      group: t.module ? "Sections" : "General",
      icon: t.icon,
      keywords: [t.module ?? ""],
      onSelect: () => navigate(t.path),
    })),
    {
      id: "action.theme",
      label: "Change theme",
      group: "Actions",
      icon: "moon" as IconName,
      keywords: ["dark", "light", "mode"],
      onSelect: () => void toggleTheme(),
    },
    {
      id: "action.logout",
      label: "Sign out",
      group: "Actions",
      icon: "logout" as IconName,
      keywords: ["log out", "exit"],
      onSelect: logout,
    },
  ];
}
